import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProdottiComponent } from '../layout/components/prodotti/prodotti.component';
import { PuntiForzaComponent } from '../layout/components/punti-forza/punti-forza.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { HttpClientModule } from '@angular/common/http';
import { ProdottiListaComponent } from '../layout/components/prodotti-lista/prodotti-lista.component';
import { ProdottiModule } from '../layout/components/prodotti/prodotti.module';
import { PuntiForzaModule } from '../layout/components/punti-forza/punti-forza.module';
import { ProdottiListaModule } from '../layout/components/prodotti-lista/prodotti-lista.module';
import { HomeTestComponent } from './homeTest.component';
import { MegaMenuModule } from 'primeng/megamenu';




@NgModule({
  declarations: [HomeTestComponent],
  imports: [
    CommonModule,
    NgbModule,
    IvyCarouselModule,
    HttpClientModule,
    ProdottiModule,
    ProdottiListaModule,
    PuntiForzaModule,
    MegaMenuModule,
    RouterModule.forChild([
      {
        path: '',
        component: HomeTestComponent,
      },
    ]),
    
    
    
  ]
})
export class HomeTestModule { }
